import React from "react";
import { RAG } from "@/lib/format";

export function RagBadge({ rag = "grey", children, className = "", testId, dot = true }) {
  const c = RAG[rag] || RAG.grey;
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-semibold ${c.bg} ${c.text} ${className}`}
    >
      {dot && <span className={`h-1.5 w-1.5 rounded-full ${c.dot}`} />}
      {children}
    </span>
  );
}
